import React, { useState, useEffect } from 'react';
import { auth } from '../firebase';

function Menu() {
    const [username, setUsername] = useState("Guest");

    // Fetch username from auth if needed
    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            if (user) {
                setUsername(user.displayName || "Admin");
            }
        });
        return () => unsubscribe();
    }, []);

    const linkStyle = {
        color: "#fff", 
        fontWeight: "500",
    };

    const headerStyle = {
        color: "#fff",
        fontWeight: "700",
        marginTop: "15px",
    };

    return (
        <div>
            <aside 
                className="main-sidebar sidebar-dark" 
                style={{
                    background: "linear-gradient(135deg, #6a11cb, #2575fc)", 
                    backgroundImage: "url('/back.jpg')",
                    backgroundBlendMode: "overlay",
                    backgroundRepeat: "repeat",
                    color: "#fff",
                    minHeight: "100vh",
                }}
            >
                {/* Brand Logo */}
                <a href="/home" className="brand-link" style={{color:"#fff"}}>
                    <img 
                        src={window.location.origin + '/user.jpg'} 
                        alt="User" 
                        className="brand-image img-circle elevation-3" 
                        style={{ opacity: '.8' }} 
                    />
                    <span className="brand-text font-weight-light">{username}</span>
                </a>

                <div className="sidebar">
                    <nav className="mt-2">
                        <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">

                            {/* Dashboard */}
                            <li className="nav-item">
                                <a href="/home" className="nav-link" style={linkStyle}>
                                    <i className="nav-icon fa fa-home" />
                                    <p>Dashboard</p>
                                </a>
                            </li>

                            {/* Properties Section */}
                            <li className="nav-header" style={headerStyle}>PROPERTIES</li>
                            <li className="nav-item">
                                <a href="/total-properties" className="nav-link" style={linkStyle}>
                                    <i className="nav-icon fa fa-building" />
                                    <p>Total Properties</p>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a href="/active-properties" className="nav-link" style={linkStyle}>
                                    <i className="nav-icon fa fa-check-circle" />
                                    <p>Active Properties</p>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a href="/pending-properties" className="nav-link" style={linkStyle}>
                                    <i className="nav-icon fa fa-hourglass-half" />
                                    <p>Pending Properties</p>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a href="/total-collection" className="nav-link" style={linkStyle}>
                                    <i className="nav-icon fa fa-money" />
                                    <p>Total Collection</p>
                                </a>
                            </li>

                            {/* Logout */}
                            <li className="nav-item" onClick={() => auth.signOut()}>
                                <a href="#0" className="nav-link" style={linkStyle}>
                                    <i className="nav-icon fa fa-sign-out" />
                                    <p>Logout</p>
                                </a>
                            </li>

                        </ul>
                    </nav>
                </div>
            </aside>
        </div>
    );
}

export default Menu;
